import type { AllGradeSubject, Revision, SchoolType } from '@mathflat/domain/SchoolSystem'

export const SCHOOL_TEST_YEARS = [2021, 2022, 2023, 2024, 2025, 2026]

type SchoolTestCurriculum = {
  schoolType: SchoolType
  revision: Revision
  gradeSubject: AllGradeSubject
}

// 22개정은 2025년 중1·고1부터 학년 순서로 전환되어, 같은 개정이라도 학년마다 시험지가 존재하는 연도가 다르다.
// 고등 15개정 선택과목은 2026년까지 시험이 남아 2025~2026년에 두 개정 시험지가 공존한다.
const MIDDLE_15_LAST_YEAR: Partial<Record<AllGradeSubject, number>> = {
  '1': 2024,
  '2': 2025,
  '3': 2026,
}
const MIDDLE_22_FIRST_YEAR: Partial<Record<AllGradeSubject, number>> = {
  '1': 2025,
  '2': 2026,
  '3': 2027,
}
const HIGH_15_ENDED_2024_SUBJECTS = new Set<AllGradeSubject>(['고등수학(상)', '고등수학(하)'])

export const getVisibleSchoolTestYears = ({
  schoolType,
  revision,
  gradeSubject,
}: SchoolTestCurriculum): number[] => {
  const isVisible = (year: number) => {
    if (schoolType === 'MIDDLE') {
      return revision === 'CURRICULUM_22'
        ? year >= (MIDDLE_22_FIRST_YEAR[gradeSubject] ?? 2025)
        : year <= (MIDDLE_15_LAST_YEAR[gradeSubject] ?? 2026)
    }
    if (revision === 'CURRICULUM_22') return year >= 2025
    return year <= (HIGH_15_ENDED_2024_SUBJECTS.has(gradeSubject) ? 2024 : 2026)
  }
  return SCHOOL_TEST_YEARS.filter(isVisible)
}
